<template>

    <div id="resources">

        <ul class="gridlist">
            <li v-for="res in resources" class="card">
                <router-link :to="`/resource/${ res.id }`" v-if="res.photo">
                    <img :src="res.photo" alt="">
                </router-link>
                <div>
                    <span style="opacity: .66">
                        {{ res.admin_unit_name }}
                    </span>
                    <h3>
                        <router-link :to="`/resource/${ res.id }`">
                            {{ res.name }}
                        </router-link>
                    </h3>
                    <p style="opacity: .66;">{{ res.resource_type_name }}</p>
                    <p>Plads til {{ res.capacity }} personer</p>
                    <p>
                        {{ res.description.substring(0,142) }} &hellip;
                    </p>
                    <p v-if="user.is_staff">{{ res.extras }}</p>
                    <p class="actions">
                        <button @click="selectIt(res)">Reservér</button>
                    </p>
                </div>
            </li>
        </ul>
        <p v-if="resources.length < 1">
            <strong>Der er ingen lokaler, som matcher det, du søger efter</strong>
        </p>

    </div>

</template>

<script>

    export default {
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            resources: function() {
                return this.$store.getters.getResourceList
            }
        },
        methods: {
            selectIt: function(res) {
                this.$store.commit('setResource', res)
                this.$emit('resource-pick', res)
            }
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #resources {

        .card {
            padding: 1rem;
        }
        .gridlist {
            
            li > div {
                flex-grow: 1;
            }
            h2 {
                margin: 0;
            }
            p {
                margin: 0;
            }
            img {
                width: 100%;
                height: auto;
            }
        }
        .actions button { 
            margin: 0;
        }

        @media screen and (min-width: $wide) {

            .gridlist li {
                display: flex;
                flex-flow: row nowrap;
            }
            .gridlist img {
                width: 8rem;
                margin-right: 1rem;
            }

        }
    }

</style>
